import { useEffect, useMemo, useState } from "react";

export default function useActivePage({ menus, page_id, document_id, form_id }) {
  const [activePageType, setActivePageType] = useState(null);

  const flatMenus = useMemo(() => {
    if (!Array.isArray(menus)) return [];

    const output = [];

    const flatten = (items) => {
      items.forEach((item) => {
        output.push(item);

        if (item.permissions && Array.isArray(item.permissions)) {
          flatten(item.permissions);
        }

        if (item.pages && Array.isArray(item.pages)) {
          flatten(item.pages);
        }

        if (item.submenu && Array.isArray(item.submenu)) {
          flatten(item.submenu);
        }
      });
    };

    flatten(menus);
    return output;
  }, [menus]);

  useEffect(() => {
    if (!flatMenus.length) return;

    const targetId = form_id || document_id || page_id;
    if (!targetId) return;

    const found = flatMenus.find((m) => m.page_slug === targetId || m.slug === targetId || m.page?.slug === targetId || m.page?._id === targetId);

    if (!found) {
      setActivePageType(null);
      return;
    }

    const page_type = found.page_type || found.page?.page_type || (found.form_id ? "FORM" : null) || (found.document_id ? "DOCUMENT" : null);

    setActivePageType(page_type);
  }, [flatMenus, page_id, document_id, form_id]);

  return activePageType;
}
